import { AxiosError, AxiosResponse } from 'axios';
import { DefaultOtpType } from '../../api/user/model';
import { POST_VERIFY_OTP_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface OtpVerifyRequest {
  otpValue: string;
  otpType: DefaultOtpType;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: AxiosResponse<void>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostOtpVerify = ({ onSuccess, onError }: Input) => {
  const postOtpVerify = async (data: OtpVerifyRequest) =>
    axiosClient.post<void>(POST_VERIFY_OTP_URL, data);

  return useCustomMutation(postOtpVerify, {
    onSuccess,
    onError,
  });
};
